import '../../utils/index.mjs';
import Avatar from './src/avatar2.mjs';
export { avatarEmits, avatarProps } from './src/avatar.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAvatar = withInstall(Avatar);

export { ElAvatar, ElAvatar as default };
//# sourceMappingURL=index.mjs.map
